import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $processing } from "services/activity/action";
import { $done } from "services/activity/action";

export const MODULE = "Mapbox";

export const $get = ActionCreator.Async(
  MODULE,
  "Get",
  ({ latOrigin, lngOrigin, latDestination, lngDestination }) => {
    return async (dispatch) => {
      dispatch($processing($get.OPERATION));

      return await Rest.GET(
        `https://api.mapbox.com/directions/v5/mapbox/cycling/${lngOrigin},${latOrigin};${lngDestination},${latDestination}?steps=true&geometries=geojson&access_token=pk.eyJ1IjoiZW52aW9pZCIsImEiOiJja3g0bWx5NjgwN3MwMm9wYXB0cnpxdm43In0.F4GEDaOI0_o6fwWkL2r0lQ`
      )
        .then((response) => {
          dispatch($get.success(response));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($get.OPERATION)));
    };
  }
);
